import { getButtonsOverrides } from './buttons';
import { getInputsOverrides } from './inputs';
import { getSurfacesOverrides } from './surfaces';
import { getNavigationOverrides } from './navigation';
import { getDatadisplayOverrides } from './dataDisplay';
import { getStepperOverrides } from './stepper';

export const getComponentOverrides = (theme) => {
  return Object.assign(
    {},
    getButtonsOverrides(theme),
    getInputsOverrides(theme),
    getSurfacesOverrides(theme),
    getNavigationOverrides(theme),
    getDatadisplayOverrides(theme),
    getStepperOverrides(theme)
  );
};
